import React from "react";
import s from "./PersonalDataFile.less";

type Props = {
  item: any;
  IconMimeType: any;
};
const PersonalDataFile = ({ item, IconMimeType }: Props) => {
  const { File } = item;
  return (
    <div className={s.wrapper}>
      <a href={File.link} download target="_blank" placeholder={File.name}>
        {IconMimeType(File)}
      </a>
    </div>
  );
};

export default PersonalDataFile;
